// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "cc33400aac160a0b3a60ee3ea0cf1958fafc1072",
  version: "1.123.4",
};
